/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Component from 'can/component/component';
import template from './history.stache';
import can from 'can';
import domUtil from 'scripts/utils/dom';

const ranges = new can.List([
    { from: 2001, to: 9999 },
    { from: 1981, to: 2000 },
    { from: 1961, to: 1980 },
    { from: 1941, to: 1960 },
    { from: 1921, to: 1940 },
    { from: 1895, to: 1920 },
]);

Component.extend({
    tag: 'history',
    template: template,
    viewModel: {
        ranges: ranges,
        activeRange: null,
        define: {
            eventCards: {
                Type: can.List,
                Value: can.List,
            },
            historyCards: {
                Type: can.List,
                Value: can.List,
            },
            tabs: {
                Type: can.List,
                Value: can.List,
            },
            activeCards: {
                get() {
                    const activeRange = this.attr('activeRange');
                    if (activeRange) {
                        const events = this.attr('eventCards').filter(
                            (event) => {
                                const year = event.attr('year');
                                return (
                                    year >= activeRange.from &&
                                    year <= activeRange.to
                                );
                            },
                        );
                        const histories = this.attr('historyCards').filter(
                            (event) => {
                                const year = event.attr('year');
                                return (
                                    year >= activeRange.from &&
                                    year <= activeRange.to
                                );
                            },
                        );
                        let cards = histories.concat(events);
                        cards.attr('comparator', function(a, b) {
                            return a.year === b.year
                                ? 0
                                : a.year < b.year
                                ? 1
                                : -1;
                        });
                        return cards;
                    }
                    return [];
                },
            },
            previousRange: {
                get() {
                    const activeRange = this.attr('activeRange');
                    if (activeRange) {
                        const ranges = this.attr('ranges');
                        const activeIndex = ranges.indexOf(activeRange);
                        if (activeIndex !== -1 && activeIndex) {
                            return ranges[activeIndex - 1];
                        }
                    }
                    return null;
                },
            },
            nextRange: {
                get() {
                    const activeRange = this.attr('activeRange');
                    if (activeRange) {
                        const ranges = this.attr('ranges');
                        const activeIndex = ranges.indexOf(activeRange);
                        if (
                            activeIndex !== -1 &&
                            activeIndex < ranges.length - 1
                        ) {
                            return ranges[activeIndex + 1];
                        }
                    }
                    return null;
                },
            },
        },
        onFilterChange(event) {
            this.selectRange(event.payload.value);
        },
        selectRange(range) {
            this.attr('activeRange', range);
            can.route.attr('year', range.from);
        },
    },

    events: {
        inserted: function() {
            can.route.ready();
            const year = can.route.attr('year');
            let activeRange = null;
            let scrollToCard = false;
            if (year) {
                const filteredRange = ranges.filter(
                    (range) => year >= range.from && year <= range.to,
                );
                if (filteredRange && filteredRange.length) {
                    activeRange = filteredRange[0];
                    scrollToCard = activeRange.from != year;
                }
            }
            this.viewModel.attr('activeRange', activeRange || ranges[0]);

            if (scrollToCard) {
                const card = this.element.find(`event-card[data-year=${year}]`);
                const headerHeight = can
                    .$(document)
                    .find('.s-top-strip')
                    .height();
                if (card && card.length) {
                    domUtil.scrollTop(card.offset().top - headerHeight);
                }
            }
        },
        '{scope} activeRange'() {
            domUtil.scrollTop(0);
        },
    },
});
